package fyi.moko.hotpl.ui.home

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import kotlinx.browser.document
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import org.w3c.dom.HTMLAnchorElement
import org.w3c.dom.HTMLInputElement
import org.w3c.files.FileReader

@Composable
actual fun rememberBackupFilePicker(): BackupFilePicker {
    return remember {
        object : BackupFilePicker {
            override fun exportJson(
                suggestedFileName: String,
                produceJson: suspend () -> String,
                onResult: (BackupExportResult) -> Unit,
            ) {
                CoroutineScope(Dispatchers.Main).launch {
                    try {
                        val json = produceJson()
                        val blob = js("new Blob([json], { type: 'application/json' })")
                        val url = kotlinx.browser.window.asDynamic().URL.createObjectURL(blob) as String
                        val a = document.createElement("a") as HTMLAnchorElement
                        a.href = url
                        a.download = suggestedFileName
                        a.click()
                        kotlinx.browser.window.asDynamic().URL.revokeObjectURL(url)
                        onResult(BackupExportResult.Success)
                    } catch (e: Exception) {
                        onResult(BackupExportResult.Failed(e))
                    }
                }
            }

            override fun importJson(onResult: (BackupImportResult) -> Unit) {
                val input = document.createElement("input") as HTMLInputElement
                input.type = "file"
                input.accept = "application/json"
                input.onchange = {
                    val file = input.files?.item(0)
                    if (file != null) {
                        val reader = FileReader()
                        reader.onload = { event ->
                            val content = event.target.asDynamic().result as String
                            onResult(BackupImportResult.Success(content))
                        }
                        reader.onerror = {
                            onResult(BackupImportResult.Failed(Exception("Failed to read file")))
                        }
                        reader.readAsText(file)
                    } else {
                        onResult(BackupImportResult.Cancelled)
                    }
                }
                input.click()
            }
        }
    }
}
